
export const enum FLOW_NODE_TYPE {
  TABLE = 'table',
  MEMO = 'memo',
  GROUP = 'custom_group',
}


